// utils/mathUtils.ts
interface KatexToImageOptions {
  dpi?: number;
  backgroundColor?: string;
  format?: 'png' | 'svg';
  inline?: boolean;
}

export const convertKatexToImages = (
  htmlContent: string, 
  options: KatexToImageOptions = {}
): string => {
  const {
    dpi = 150,
    backgroundColor = 'white',
    format = 'png',
    inline = true
  } = options;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;
  
  const katexElements = tempDiv.querySelectorAll('span.__se__katex.katex');
  
  katexElements.forEach((element) => {
    const span = element as HTMLElement; 
    const dataExp = span.getAttribute('data-exp');
    if (dataExp) {
      // MANTENER el span original, solo agregar atributos para ignorar resaltado
      span.setAttribute('data-ignore-highlight', 'true');
      span.setAttribute('data-original-katex', 'true');
      
      // Preservar el display inline natural del span
      // No modificar estilos a menos que sea necesario
      if (span.getAttribute('style')) {
        // Mantener estilos existentes
        const existingStyle = span.getAttribute('style') || '';
        span.setAttribute('style', existingStyle);
      }
      
      // Asegurar que se mantenga inline
      span.style.display = 'inline';
      span.style.verticalAlign = 'middle';
    }
  });
  
  return tempDiv.innerHTML;
};